module.exports = __webpack_public_path__ + "img/fl.ddb17523.png";